import SumToTenGame from "./SumToTenGame";
export default SumToTenGame;
